import { useEffect, useMemo, useState } from "react";
import { Typography } from "@mui/material";

import { Container, DateButton, DaysContainer, HeaderRow } from "./styles";

import { ReportDownload } from "..";
import { useFilter } from "../../../Hooks/useFilter";
import { format, sub } from "date-fns";
import { comparingDates } from "../../../Utils/compareCustomFilterDateAndStaticFilterDate";

type DateFilterProps = {
  setPageToFirst: () => void;
  tableName: string;
  hasData: boolean;
};

export const DateFilter = ({ setPageToFirst, tableName, hasData }: DateFilterProps) => {
  const { handleApplyFilters, getFilterObj } = useFilter();
  const filterObj = getFilterObj(tableName) as { start_date?: string; end_date?: string };

  const [dateButtonSelected, setDateButtonSelected] = useState<number>(7);

  const options = useMemo(
    () => [
      { value: 7, label: "7 dias" },
      { value: 15, label: "15 dias" },
      { value: 30, label: "1 mês" },
      { value: 60, label: "2 meses" },
      { value: 90, label: "3 meses" },
      { value: 180, label: "6 meses" },
    ],
    []
  );

  const applyPeriod = (value: number) => {
    setDateButtonSelected(value);
    const nextFilter = {
      start_date: format(sub(new Date(), { days: value }), "yyyy-MM-dd"),
      end_date: format(new Date(), "yyyy-MM-dd"),
    };

    handleApplyFilters(tableName, nextFilter);
    setPageToFirst();
  };

  useEffect(() => {
    if (
      filterObj.start_date !== undefined &&
      filterObj.end_date !== undefined &&
      filterObj.start_date !== "" &&
      filterObj.end_date !== ""
    ) {
      setDateButtonSelected(comparingDates(filterObj.start_date, filterObj.end_date));
    }
  }, [filterObj.start_date, filterObj.end_date]);

  return (
    <Container>
      <HeaderRow>
        <div className="title">
          <Typography variant="subtitle1" gutterBottom>
            Filtrar dados por período
          </Typography>
        </div>
        <div className="actions">
          <ReportDownload
            hasData={hasData}
            endDate={filterObj.end_date}
            startDate={filterObj.start_date}
            type={tableName}
          />
        </div>
      </HeaderRow>
      <DaysContainer>
        {options.map((opt) => (
          <DateButton key={opt.value} selected={dateButtonSelected === opt.value} onClick={() => applyPeriod(opt.value)}>
            {opt.label}
          </DateButton>
        ))}
      </DaysContainer>
      <hr
        style={{
          border: "1px solid #f2f2f2",
          height: 2,
          background: "#f2f2f2",
          width: "100%",
          marginTop: 20,
        }}
      />
    </Container>
  );
};

